import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';
import { consts as removeUserCommunityConsts } from './removeUserCommunity';
import { COMMUNITIES_USER_ROLES } from '../../constants';

const supportedActions = ['LOAD_MODERATORS', 'LOAD_OLDER_MODERATORS', 'CLEAR'];

export const consts = createConsts(
  'communities',
  'moderatorsList',
  ...supportedActions,
);

export const actions = createActions(consts);

const reducer = (state = [], action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.LOAD_OLDER_MODERATORS:
      return [...state, ...payload];
    case consts.LOAD_MODERATORS:
      return payload;
    case consts.CLEAR:
      return [];
    case removeUserCommunityConsts.SEND:
      if (payload.userType === COMMUNITIES_USER_ROLES.MODERATOR) {
        return state.filter(item => item.id !== payload.memberId);
      }
      return state;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/communities/moderatorsList.js